import { useQuery } from "@tanstack/react-query";
import api from "../api";
import { ScrapingState } from "../types/scrapingState";
import { networkKeys } from "../../samples/queryKeys";
import { route } from "../../../shim/jsbridge";

export const useUrlScrapingState = (url: string) =>
  useQuery({
    queryKey: networkKeys.urlScrapingState(url),
    queryFn: async () => {
      try {
        const apiUrl = route("url-scraping-state");
        const response = await api.get(apiUrl, { params: { url } });
        return response.data;
      } catch (err) {
        return {
          state: ScrapingState.PENDING,
          state_message: "Unable to fetch scraping state",
          created_at: null,
          updated_at: null
        };
      }
    },
    enabled: !!url
  });
